module.exports = __webpack_public_path__ + "img/1484114723.17c69be1.jpg";